import { render, staticRenderFns } from "./row-textarea.vue?vue&type=template&id=37a44988&scoped=true"
import script from "./row-textarea.vue?vue&type=script&lang=js"
export * from "./row-textarea.vue?vue&type=script&lang=js"
import style0 from "./row-textarea.vue?vue&type=style&index=0&id=37a44988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a44988",
  null
  
)

export default component.exports